import type { RichtextContentsLinksFetchedData } from "@robe/core";
import { Fragment, ReactNode } from "react";
import { isRichtextPlainText } from "../../utils";
import type { Node } from "slate";
import type { RenderElementProps, RenderLeafProps } from "slate-react";

interface SlateValueProps<T> {
  value: Node[];
  contentsSlugs?: RichtextContentsLinksFetchedData;
  renderLeaf: (elementProps: T) => (props: RenderLeafProps) => ReactNode;
  renderElement: (elementProps: T, contentsSlugs?: RichtextContentsLinksFetchedData) => (props: RenderElementProps) => ReactNode;
  elementProps: T;
}

export const SlateValue = <T extends {}>({ value, contentsSlugs, elementProps, ...props }: SlateValueProps<T> & T) => {
  return (
    <>
      {value?.map((n, i) => (
        <Fragment key={i}>
          {isRichtextPlainText(n)
            ? props.renderLeaf(elementProps)({ children: n.text, text: n, leaf: n, attributes: {} as any })
            : props.renderElement(
              elementProps,
              contentsSlugs
            )({
              children: <SlateValue {...(props as any)} contentsSlugs={contentsSlugs} value={n.children} elementProps={elementProps} />,
              element: n,
              attributes: {} as any,
            })}
        </Fragment>
      ))}
    </>
  );
};
